export default "__VITE_ASSET__Z4tUTJby__"